var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-balance",
    clipPath: "url(#clip0_1607_890)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.3693 0C7.02869 0 6.75283 0.275866 6.75283 0.616476V1.23295C4.87259 1.39709 3.12637 2.27479 1.87113 3.68426C0.616593 5.09444 -0.0522789 6.93077 0.00319407 8.81788C0.0579056 10.7043 0.83158 12.499 2.16629 13.8337C3.50099 15.1685 5.29562 15.9422 7.18213 15.9968C9.06932 16.0523 10.9056 15.3834 12.3158 14.1289C13.7252 12.8736 14.6029 11.1274 14.7671 9.24718H15.3835C15.5469 9.24718 15.7041 9.18245 15.8197 9.06686C15.9353 8.95127 16 8.79408 16 8.63071C16 6.34196 15.0907 4.14671 13.4725 2.5275C11.8535 0.909256 9.65806 0 7.3693 0ZM7.98578 1.23295C9.73734 1.37397 11.3818 2.13378 12.624 3.37592C13.8663 4.61807 14.626 6.26261 14.767 8.01419H7.98578V1.23295ZM7.3693 14.7954C5.24014 14.7954 3.2613 13.6973 2.13547 11.8896C1.01041 10.0826 0.897134 7.82244 1.83572 5.91127C2.77507 4.00019 4.63462 2.70954 6.75293 2.49668V8.63067C6.75293 8.79403 6.81766 8.95123 6.93325 9.06682C7.04883 9.18241 7.20603 9.24714 7.3694 9.24714H13.5342C13.3808 10.7729 12.6641 12.1869 11.5243 13.2127C10.3846 14.2391 8.9027 14.8031 7.3693 14.7954Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1607_890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.79c0b69867843dec477449351a029647.svg";
export { ForwardRef as ReactComponent };